import React, { useState } from 'react'
import Footer from '../../footer/Footer'
import { Button, Grid, Box, Typography } from '@material-ui/core'
import { Cancel, CheckCircleOutline } from '@mui/icons-material';
import { userServices } from '../../../services/Services';
import { useSelector, useDispatch } from 'react-redux';
import { setLocation } from '../../../redux/actions';
import Skeleton from '@mui/material/Skeleton';
import { useNavigate } from 'react-router-dom';

interface State {
    expand: boolean,
    data: any,
    selected: any
}
interface IProps {
    history: any;
    dt: string; // Add the 'dt' property to the interface
    // any other props that come into the component
}

function Forecast(props: IProps) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const stateR: any = useSelector(state => state);
    const [state, setstate] = React.useState<State>({
        expand: false,
        data: null,
        selected: null,
    });

    const [lat, setLat] = useState(0);
    const [lng, setLng] = useState(0);
    const cityName = window.location.search.slice(1).split("%20").join(" ").split('&')[0];
    const params = new URLSearchParams(window.location.search);

    const viewDay = (value: any, lat: number, lng: number) => () => {
        setstate({ ...state, selected: state.selected === value ? null : value });
        navigate({
            pathname: "/view",
            search: `?${cityName}&lat=${lat}&lng=${lng}`,
        });
    }

    // react useEffect
    React.useEffect(() => {
        setLat(parseFloat(params.get("lat") || "0"));
        setLng(parseFloat(params.get("lng") || "0"));
        setstate(prev => ({ ...prev, data: "" }));
        dispatch(setLocation(cityName))
        const endpoint = `/forecast?q=${cityName}&lat=${lat}&lng=${lng}&units=${stateR.states.unit}`
        userServices
            .getReq(endpoint)
            .then((val) => {
                setstate({ ...state, data: val })
            })
            .catch((err) =>
                alert("City/Town not found. To make the search more precise put the city name, comma, 2-letter country code (ISO3166)."))
    }, [cityName, stateR.states.unit]);
    
    const filtered = state.data?.daily ? state.data.daily.data : [];
    const weeklySummary = state.data?.daily ? state.data?.daily.summary : "";
    const unadvisableConditions = ["light rain.", "rain.", "snow.", "fog.", "sleet.", "drizzle.", "tornado."];
    const okayConditions = ["possible drizzle.", "possible light rain."];

    var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    return (
        <div>
            <div className="py-2">
                <h1 className="text-4xl font bold text-center">Weather Forecast for</h1>

                {!state.data &&
                    <Skeleton className="h-20 w-1/4 mx-auto" />
                }

                {state.data &&
                    <h2 className="text-4xl font bold text-center pb-3">{cityName}</h2>
                }

                <Grid container justifyContent="center">
                    <Grid item md={8}>
                        {!state.data &&
                            <Box boxShadow=" 0px 0px 1px 0px rgba(50, 50, 50, 1)"
                                className="p-4">
                                <Skeleton className="h-28" animation="wave" />
                                <Skeleton className="h-28 mt-1" animation="wave" />
                                <Skeleton className="h-28 mt-1" animation="wave" />
                            </Box>
                        }

                        <Grid item md={12} className="text-center items-center">
                            <Box py={3}>                                
                                <Typography className="text-center pb-3">
                                    <span className="font-bold">Forecast Summary:</span> {weeklySummary}
                                </Typography>
                            </Box>
                        </Grid>

                        {state.data && filtered.map((value: any, index: number) => (
                            <div key={Math.random()} className="box-shadow overflow-x">
                                <Box py={0} px={0} onClick={viewDay(value, lat, lng)}
                                    className="hover:bg-blue-300 cursor-pointer w-full inline-flex relative justify-center items-center">
                                    
                                    <div className="grid grid-cols-6 gap-2 pt-30 pb-30">
                                        {
                                            <div className="col-span-2">
                                                <img src={`/icons/${value.icon}.svg`} alt="weather" />
                                            </div>
                                        }

                                        <div className="col-span-2">
                                            <div className="mx-12 grid items-center">
                                                {
                                                    stateR.states.unit === "metric" ?

                                                    // metric unit conditions
                                                    <>
                                                        {
                                                            value.temperatureMin <= 10 &&
                                                            <>
                                                                <Cancel fontSize="large" className="text-red-600 mx-auto" />

                                                                <span className="text-center font-semibold text-lg mx-auto">Not Advisable - Too Cold</span>
                                                            </>
                                                        }

                                                        {
                                                            value.temperatureMax >= 40 &&
                                                            <>
                                                                <Cancel fontSize="large" className="text-red-600 mx-auto" />

                                                                <span className="text-center font-semibold text-lg mx-auto">Not Advisable - Too Hot</span>
                                                            </>
                                                        }

                                                        {
                                                            value.temperatureMin > 10 && value.temperatureMax < 40 &&
                                                            <>
                                                            {
                                                                unadvisableConditions.includes(value.summary.toLowerCase()) ? (
                                                                <>
                                                                    <Cancel fontSize="large" className="text-red-600 mx-auto" />
                                                                    
                                                                    <span className="text-center font-semibold text-lg mx-auto text-center">Not Advisable</span>
                                                                </>
                                                                ) : okayConditions.includes(value.summary.toLowerCase()) ? (
                                                                <>
                                                                    <CheckCircleOutline fontSize="large" className="text-amber-600 mx-auto" />
                                                                    
                                                                    <span className="text-center font-semibold text-lg mx-auto text-center">Okay</span>
                                                                </>
                                                                ) : (
                                                                <>
                                                                    <CheckCircleOutline fontSize="large" className="text-green-600 mx-auto" />
                                                                    
                                                                    <span className="text-center font-semibold text-lg mx-auto">Optimal</span>
                                                                </>
                                                                )
                                                            }
                                                            </>
                                                        }

                                                        {
                                                            value.windSpeed > 16 && value.temperatureMax < 24 &&
                                                            <span className="text-center font-semibold text-lg mx-auto">A bit windy</span>
                                                        }

                                                        {
                                                            value.windSpeed > 34 &&
                                                            <span className="text-center font-semibold text-lg mx-auto">Too windy</span>
                                                        }
                                                    </>

                                                    :
                                                    // imperial unit conditions
                                                    <>
                                                        {
                                                            value.temperatureMin <= 50 &&
                                                            <>
                                                                <Cancel fontSize="large" className="text-red-600 mx-auto" />

                                                                <span className="text-center font-semibold text-lg mx-auto">Not Advisable - Too Cold</span>
                                                            </>
                                                        }

                                                        {
                                                            value.temperatureMax >= 104 &&
                                                            <>
                                                                <Cancel fontSize="large" className="text-red-600 mx-auto" />

                                                                <span className="text-center font-semibold text-lg mx-auto">Not Advisable - Too Hot</span>
                                                            </>
                                                        }

                                                        {
                                                            value.temperatureMin > 50 && value.temperatureMax < 104 &&
                                                            <>
                                                            {
                                                                unadvisableConditions.includes(value.summary.toLowerCase()) ? (
                                                                <>
                                                                    <Cancel fontSize="large" className="text-red-600 mx-auto" />
                                                                    
                                                                    <span className="text-center font-semibold text-lg mx-auto text-center">Not Advisable</span>
                                                                </>
                                                                ) : okayConditions.includes(value.summary.toLowerCase()) ? (
                                                                <>
                                                                    <CheckCircleOutline fontSize="large" className="text-amber-600 mx-auto" />
                                                                                
                                                                    <span className="text-center font-semibold text-lg mx-auto text-center">Okay</span>
                                                                </>
                                                                ) : (
                                                                <>
                                                                    <CheckCircleOutline fontSize="large" className="text-green-8600 mx-auto" />
                                                                                    
                                                                    <span className="text-center font-semibold text-lg mx-auto">Optimal</span>
                                                                </>
                                                                )
                                                            }
                                                            </>
                                                        }

                                                        {
                                                            value.windSpeed > 13 && value.temperatureMax < 24 &&
                                                            <span className="text-center font-semibold text-lg mx-auto">A bit windy</span>
                                                        }
                                                        
                                                        {
                                                            value.windSpeed > 24 &&
                                                            <span className="text-center font-semibold text-lg mx-auto">Too windy</span>
                                                        }
                                                    </>
                                                }
                                            </div>
                                        </div>

                                        <div className="col-span-2 weather-desc">
                                            <Grid container>
                                                <Box py={0} px={0}>
                                                    <Typography className="font-bold text-center text-lg">
                                                        {days[new Date(value.time * 1000).getDay()]}, {months[new Date(value.time * 1000).getMonth()]} {new Date(value.time * 1000).getDate()}, {new Date(value.time * 1000).getFullYear()}

                                                    </Typography>
                                                </Box>

                                                <Box py={0} px={0}>
                                                    <Typography className="text-center text-lg font-semibold">
                                                        {value.summary}
                                                    </Typography>
                                                </Box>

                                                <Box py={0} px={0}>
                                                    <Typography className="text-center text-lg font-semibold">
                                                        {value.temperatureMin}°- {value.temperatureMax}° {stateR.states.unit === "metric" ? "C" : "F"}
                                                    </Typography>
                                                </Box>
                                            </Grid>                                    
                                        </div>

                                        <div className="col-span-2">
                                            <Button variant="contained"
                                                className="bg-yellow-500 pr-2 hover:bg-yellow-600 font-bold">
                                                View Day
                                            </Button>
                                        </div>
                                    </div>
                                </Box>

                                <Box bgcolor="#E5E5E5" py={2} px={2}>
                                    <Grid container>
                                        <Grid item md={6}>
                                            <Box bgcolor="#E5E5E5" mx="auto">
                                                <Typography className="text-sm pr-30 pl-30">
                                                    <span className="font-bold">Viablility</span>
                                                    <span className="block">
                                                        {new Date(value.time * 1000).getHours()}hrs
                                                    </span>
                                                </Typography>

                                                <Typography className="text-sm pr-30 pl-30">
                                                    <span className="font-bold">Temp</span>
                                                    <span className="block">
                                                        {value.temperatureMax}
                                                        {stateR.states.unit === "metric" ? "°C" : "°F"}
                                                    </span>
                                                </Typography>

                                                <Typography className="text-sm pr-30 pl-30">
                                                    <span className="font-bold">Rain</span>
                                                    <span className="block">
                                                        {value.precipType === "rain" ? value.precipIntensity : 0}
                                                        {stateR.states.unit === "metric" ? "mm" : "in"}
                                                    </span>

                                                </Typography>
                                            </Box>
                                        </Grid>

                                        <Grid item md={6}>
                                            <Box bgcolor="#E5E5E5" mx="auto">
                                                <Typography className="text-sm pr-30 pl-30">
                                                    <span className="font-bold">Snow</span>
                                                    <span className="block">
                                                        {value.precipType === "snow" ? value.snow : 0}
                                                        {stateR.states.unit === "metric" ? "mm" : "in"}
                                                    </span>

                                                </Typography>

                                                <Typography className="text-sm pr-30 pl-30">
                                                    <span className="font-bold">Wind</span>
                                                    <span className="block">
                                                        {value.windSpeed}
                                                        {stateR.states.unit === "metric" ? "KM/H" : "MPH"}
                                                    </span>
                                                </Typography>

                                                <Typography className="text-sm pr-30 pl-30">
                                                    <span className="font-bold">Humidity </span>
                                                    <span className="block">{value.humidity}%</span>
                                                
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </div>
                        ))}

                    </Grid>
                </Grid>
            </div>
            <Footer />
        </div>
    )
};
export default Forecast;
